import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import image from "../../../assets/technical/img_16.jpg";

const Justification = () => {
  return (
    <Box
      padding={{ xs: "35% 0% 10% 0%", sm: "5% 0% 1% 0%" }}
      sx={{
        position: "relative",
        "&::after": {
          position: "absolute",
          content: '""',
          width: "30%",
          zIndex: 1,
          top: 0,
          right: 0,
          height: "25%",
          backgroundSize: "18px 18px",
          backgroundImage: `radial-gradient(${"#00AEEF"} 20%, transparent 30%)`,
          opacity: 0.1,
        },
      }}
    >
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignCenter={"center"}
        flexWrap={"wrap"}
        width={"100%"}
      >
        <Box
          width={{ xs: "100%", sm: "50%" }}
          paddingTop={{ xs: "10%", sm: "3%" }}
          display={{ xs: "none", sm: "block" }}
        >
          <Box
            component="img"
            height={{ xs: "27vh", sm: "350px" }}
            width={{ xs: "100%", sm: "100%" }}
            src={image}
            alt={"justification_image"}
            sx={{
              objectFit: "cover",
            }}
          />
        </Box>
        <Box
          width={{ xs: "100%", sm: "50%" }}
          padding={{ xs: "5% 1%", sm: "3% 0% 3% 3%" }}
          marginRight={{ xs: "0%", sm: "0%" }}
        >
          <Box
            width={{ xs: "100%", sm: "100%" }}
            marginLeft={{ xs: "0%", sm: "0%" }}
          >
            <Typography
              variant={"h3"}
              fontWeight={900}
              textAlign={"left"}
              color={"#00AEEF"}
              paddingBottom={"1%"}
            >
              <Typography
                component={"span"}
                variant={"h3"}
                color="#3E4095"
                fontWeight={900}
              >
                Our {""}
              </Typography>
              Justification
            </Typography>
          </Box>
          <Box
            width={{ xs: "100%", sm: "50%" }}
            paddingTop={{ xs: "5%", sm: "3%" }}
            display={{ xs: "block", sm: "none" }}
          >
            <Box
              component="img"
              height={{ xs: "27vh", sm: "350px" }}
              width={{ xs: "100%", sm: "100%" }}
              src={image}
              alt={"justification_image"}
              sx={{
                objectFit: "cover",
              }}
            />
          </Box>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            data-aos={"fade-up"}
            lineHeight={"1.625em"}
            padding={{ xs: "4% 0%", sm: "0% 10% 1% 0%" }}
          >
            We currently have an average of 11kg per capita consumption of fish
            in Nigeria and we still result to importation to supply about 59% of
            this demand. Based on the F.A.O Standard of an average of 21kg per
            capita consumption of Fish, we would need to raise about 400,000 new
            Fish Farmers to meet this standard if we do not want to continue
            turning to importation as a means of filling up the supply gap.
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            data-aos={"fade-up"}
            lineHeight={"1.625em"}
            padding={"2% 10% 1% 0%"}
          >
            With a population growth rate of 2.6%, after we must have met this
            supply gap by injecting 400,000 new Fish Farmers into the
            Aquaculture industry, we would need to be injecting a further 5,000
            new Fish Farmers every year to satisfy this growth rate.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Justification;
